import React from 'react';
import t from 'lib/translation';
import { DASHBOARD_PATH, SETTINGS_PATH } from '../routes';
import { useAppBridge } from '../containers/AppBridge';
import { isPageDisabled } from '../platform/platform';
import { NavMenu } from '@shopify/app-bridge-react';

const navItems = [
  { id: 'dashboard', content: t('header.tabs.1'), pathname: DASHBOARD_PATH },
  { id: 'certificates', content: t('header.tabs.9'), pathname: '/certificate' },
  {
    id: 'customization',
    content: t('header.tabs.10'),
    pathname: '/customizations',
  },
  { id: 'tokengates', content: t('header.tabs.7'), pathname: '/tokengates' },
  { id: 'NFTs', content: t('header.tabs.2'), pathname: '/drops' },
  { id: 'settings', content: t('header.tabs.4'), pathname: SETTINGS_PATH },
  { id: 'reports', content: t('header.tabs.12'), pathname: '/reports' },
];

const Header = () => {
  const { platform } = useAppBridge();

  let filteredItems = navItems;

  if (isPageDisabled('tokengates', platform)) {
    filteredItems = filteredItems.filter((item) => item.id !== 'tokengates');
  }

  // The first link is the app's home link (rel="home"). App Bridge uses it as
  // the destination for the app's name in the admin nav and does not render it
  // as a separate menu item. Remaining links highlight automatically, including
  // when a sub-page nested under their path is active.
  return (
    <NavMenu>
      {filteredItems.map((item, index) => (
        <a
          key={item.id}
          href={item.pathname}
          rel={index === 0 ? 'home' : undefined}
        >
          {item.content}
        </a>
      ))}
    </NavMenu>
  );
};

export default Header;
